require("core-js/modules/web.dom.iterable");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.reflect.construct");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.string.repeat");

var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray");

require("core-js/modules/es6.array.is-array");

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

require("core-js/modules/es6.array.reduce");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

var _construct = require("/opt/build/repo/node_modules/@babel/runtime/helpers/construct");

var _get = require("/opt/build/repo/node_modules/@babel/runtime/helpers/get");

require("core-js/modules/es6.array.map");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.array.for-each");

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) : typeof define === 'function' && define.amd ? define(['exports'], factory) : (global = global || self, factory(global.railroadDiagrams = {}));
})(this, function (exports) {
  'use strict';

  var _marked = /*#__PURE__*/_regeneratorRuntime.mark(enumerate);

  var funcs = {};
  var Options = {
    DEBUG: false,
    VS: 8,
    AR: 10,
    DIAGRAM_CLASS: 'railroad-diagram',
    STROKE_ODD_PIXEL_LENGTH: true,
    INTERNAL_ALIGNMENT: 'center',
    CHAR_WIDTH: 8.5,
    COMMENT_CHAR_WIDTH: 7
  };
  var defaultCSS = "\n\tsvg {\n\t\tbackground-color: hsl(30,20%,95%);\n\t}\n\tpath {\n\t\tstroke-width: 3;\n\t\tstroke: black;\n\t\tfill: rgba(0,0,0,0);\n\t}\n\ttext {\n\t\tfont: bold 14px monospace;\n\t\ttext-anchor: middle;\n\t\twhite-space: pre;\n\t}\n\ttext.diagram-text {\n\t\tfont-size: 12px;\n\t}\n\ttext.diagram-arrow {\n\t\tfont-size: 16px;\n\t}\n\ttext.label {\n\t\ttext-anchor: start;\n\t}\n\ttext.comment {\n\t\tfont: italic 12px monospace;\n\t}\n\tg.non-terminal text {\n\t\t/*font-style: italic;*/\n\t}\n\trect {\n\t\tstroke-width: 3;\n\t\tstroke: black;\n\t\tfill: hsl(120,100%,90%);\n\t}\n\trect.group-box {\n\t\tstroke: gray;\n\t\tstroke-dasharray: 10 5;\n\t\tfill: none;\n\t}\n\tpath.diagram-text {\n\t\tstroke-width: 3;\n\t\tstroke: black;\n\t\tfill: white;\n\t\tcursor: help;\n\t}\n\tg.diagram-text:hover path.diagram-text {\n\t\tfill: #eee;\n\t}";

  var FakeSVG = /*#__PURE__*/function () {
    function FakeSVG(tagName, attrs, text) {
      _classCallCheck(this, FakeSVG);

      if (text) this.children = text;else this.children = [];
      this.tagName = tagName;
      this.attrs = unnull(attrs, {});
    }

    _createClass(FakeSVG, [{
      key: "format",
      value: function format() {}
    }, {
      key: "addTo",
      value: function addTo(parent) {
        if (parent instanceof FakeSVG) {
          parent.children.push(this);
          return this;
        } else {
          var svg = this.toSVG();
          parent.appendChild(svg);
          return svg;
        }
      }
    }, {
      key: "toSVG",
      value: function toSVG() {
        var el = SVG(this.tagName, this.attrs);

        if (typeof this.children == 'string') {
          el.textContent = this.children;
        } else {
          this.children.forEach(function (e) {
            el.appendChild(e.toSVG());
          });
        }

        return el;
      }
    }, {
      key: "toString",
      value: function toString() {
        var str = '<' + this.tagName;
        var group = this.tagName == "g" || this.tagName == "svg";

        for (var attr in this.attrs) {
          str += ' ' + attr + '="' + (this.attrs[attr] + '').replace(/&/g, '&amp;').replace(/"/g, '&quot;') + '"';
        }

        str += '>';
        if (group) str += "\n";

        if (typeof this.children == 'string') {
          str += escapeString(this.children);
        } else {
          this.children.forEach(function (e) {
            str += e;
          });
        }

        str += '</' + this.tagName + '>\n';
        return str;
      }
    }, {
      key: "walk",
      value: function walk(cb) {
        cb(this);
      }
    }]);

    return FakeSVG;
  }();

  var Path = /*#__PURE__*/function (_FakeSVG) {
    _inherits(Path, _FakeSVG);

    var _super = _createSuper(Path);

    function Path(x, y) {
      var _this;

      _classCallCheck(this, Path);

      _this = _super.call(this, 'path');
      _this.attrs.d = "M" + x + ' ' + y;
      return _this;
    }

    _createClass(Path, [{
      key: "m",
      value: function m(x, y) {
        this.attrs.d += 'm' + x + ' ' + y;
        return this;
      }
    }, {
      key: "h",
      value: function h(val) {
        this.attrs.d += 'h' + val;
        return this;
      }
    }, {
      key: "right",
      value: function right(val) {
        return this.h(Math.max(0, val));
      }
    }, {
      key: "left",
      value: function left(val) {
        return this.h(-Math.max(0, val));
      }
    }, {
      key: "v",
      value: function v(val) {
        this.attrs.d += 'v' + val;
        return this;
      }
    }, {
      key: "down",
      value: function down(val) {
        return this.v(Math.max(0, val));
      }
    }, {
      key: "up",
      value: function up(val) {
        return this.v(-Math.max(0, val));
      }
    }, {
      key: "arc",
      value: function arc(sweep) {
        var x = Options.AR;
        var y = Options.AR;

        if (sweep[0] == 'e' || sweep[1] == 'w') {
          x *= -1;
        }

        if (sweep[0] == 's' || sweep[1] == 'n') {
          y *= -1;
        }

        var cw;

        if (sweep == 'ne' || sweep == 'es' || sweep == 'sw' || sweep == 'wn') {
          cw = 1;
        } else {
          cw = 0;
        }

        this.attrs.d += "a" + Options.AR + " " + Options.AR + " 0 0 " + cw + ' ' + x + ' ' + y;
        return this;
      }
    }, {
      key: "arc_8",
      value: function arc_8(start, dir) {
        var arc = Options.AR;
        var s2 = 1 / Math.sqrt(2) * arc;
        var s2inv = arc - s2;
        var path = "a " + arc + " " + arc + " 0 0 " + (dir == 'cw' ? "1" : "0") + " ";
        var sd = start + dir;
        var offset = sd == 'ncw' ? [s2, s2inv] : sd == 'necw' ? [s2inv, s2] : sd == 'ecw' ? [-s2inv, s2] : sd == 'secw' ? [-s2, s2inv] : sd == 'scw' ? [-s2, -s2inv] : sd == 'swcw' ? [-s2inv, -s2] : sd == 'wcw' ? [s2inv, -s2] : sd == 'nwcw' ? [s2, -s2inv] : sd == 'nccw' ? [-s2, s2inv] : sd == 'nwccw' ? [-s2inv, s2] : sd == 'wccw' ? [s2inv, s2] : sd == 'swccw' ? [s2, s2inv] : sd == 'sccw' ? [s2, -s2inv] : sd == 'seccw' ? [s2inv, -s2] : sd == 'eccw' ? [-s2inv, -s2] : sd == 'neccw' ? [-s2, -s2inv] : null;
        path += offset.join(" ");
        this.attrs.d += path;
        return this;
      }
    }, {
      key: "l",
      value: function l(x, y) {
        this.attrs.d += 'l' + x + ' ' + y;
        return this;
      }
    }, {
      key: "format",
      value: function format() {
        this.attrs.d += 'h.5';
        return this;
      }
    }]);

    return Path;
  }(FakeSVG);

  var DiagramMultiContainer = /*#__PURE__*/function (_FakeSVG2) {
    _inherits(DiagramMultiContainer, _FakeSVG2);

    var _super2 = _createSuper(DiagramMultiContainer);

    function DiagramMultiContainer(tagName, items, attrs, text) {
      var _this2;

      _classCallCheck(this, DiagramMultiContainer);

      _this2 = _super2.call(this, tagName, attrs, text);
      _this2.items = items.map(wrapString);
      return _this2;
    }

    _createClass(DiagramMultiContainer, [{
      key: "walk",
      value: function walk(cb) {
        cb(this);
        this.items.forEach(function (x) {
          return x.walk(cb);
        });
      }
    }]);

    return DiagramMultiContainer;
  }(FakeSVG);

  var Diagram = /*#__PURE__*/function (_DiagramMultiContaine) {
    _inherits(Diagram, _DiagramMultiContaine);

    var _super3 = _createSuper(Diagram);

    function Diagram() {
      var _this3;

      _classCallCheck(this, Diagram);

      for (var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++) {
        items[_key] = arguments[_key];
      }

      _this3 = _super3.call(this, 'svg', items, {
        "class": Options.DIAGRAM_CLASS
      });

      if (!(_this3.items[0] instanceof Start)) {
        _this3.items.unshift(new Start());
      }

      if (!(_this3.items[_this3.items.length - 1] instanceof End)) {
        _this3.items.push(new End());
      }

      _this3.up = _this3.down = _this3.height = _this3.width = 0;

      var _iterator = _createForOfIteratorHelper(_this3.items),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          _this3.width += item.width + (item.needsSpace ? 20 : 0);
          _this3.up = Math.max(_this3.up, item.up - _this3.height);
          _this3.height += item.height;
          _this3.down = Math.max(_this3.down - item.height, item.down);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      _this3.formatted = false;
      return _this3;
    }

    _createClass(Diagram, [{
      key: "format",
      value: function format(paddingt, paddingr, paddingb, paddingl) {
        paddingt = unnull(paddingt, 20);
        paddingr = unnull(paddingr, paddingt, 20);
        paddingb = unnull(paddingb, paddingt, 20);
        paddingl = unnull(paddingl, paddingr, 20);
        var x = paddingl;
        var y = paddingt;
        y += this.up;
        var g = new FakeSVG('g', Options.STROKE_ODD_PIXEL_LENGTH ? {
          transform: 'translate(.5 .5)'
        } : {});

        for (var i = 0; i < this.items.length; i++) {
          var item = this.items[i];

          if (item.needsSpace) {
            new Path(x, y).h(10).addTo(g);
            x += 10;
          }

          item.format(x, y, item.width).addTo(g);
          x += item.width;
          y += item.height;

          if (item.needsSpace) {
            new Path(x, y).h(10).addTo(g);
            x += 10;
          }
        }

        this.attrs.width = this.width + paddingl + paddingr;
        this.attrs.height = this.up + this.height + this.down + paddingt + paddingb;
        this.attrs.viewBox = "0 0 " + this.attrs.width + " " + this.attrs.height;
        g.addTo(this);
        this.formatted = true;
        return this;
      }
    }, {
      key: "addTo",
      value: function addTo(parent) {
        if (!parent) {
          var scriptTag = document.getElementsByTagName('script');
          scriptTag = scriptTag[scriptTag.length - 1];
          parent = scriptTag.parentNode;
        }

        return _get(_getPrototypeOf(Diagram.prototype), "addTo", this).call(this, parent);
      }
    }, {
      key: "toSVG",
      value: function toSVG() {
        if (!this.formatted) {
          this.format();
        }

        return _get(_getPrototypeOf(Diagram.prototype), "toSVG", this).call(this);
      }
    }, {
      key: "toString",
      value: function toString() {
        if (!this.formatted) {
          this.format();
        }

        return _get(_getPrototypeOf(Diagram.prototype), "toString", this).call(this);
      }
    }, {
      key: "toStandalone",
      value: function toStandalone(style) {
        if (!this.formatted) {
          this.format();
        }

        var s = new FakeSVG('style', {}, style || defaultCSS);
        this.children.push(s);
        this.attrs.xmlns = "http://www.w3.org/2000/svg";
        this.attrs['xmlns:xlink'] = "http://www.w3.org/1999/xlink";

        var result = _get(_getPrototypeOf(Diagram.prototype), "toString", this).call(this);

        this.children.pop();
        delete this.attrs.xmlns;
        return result;
      }
    }], [{
      key: "fromJSON",
      value: function fromJSON() {
        var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return diagramFromJSON(Diagram, input);
      }
    }]);

    return Diagram;
  }(DiagramMultiContainer);

  funcs.Diagram = function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _construct(Diagram, args);
  };

  funcs.Diagram.fromJSON = Diagram.fromJSON;

  var ComplexDiagram = /*#__PURE__*/function (_FakeSVG3) {
    _inherits(ComplexDiagram, _FakeSVG3);

    var _super4 = _createSuper(ComplexDiagram);

    function ComplexDiagram() {
      var _this4;

      _classCallCheck(this, ComplexDiagram);

      for (var _len3 = arguments.length, items = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        items[_key3] = arguments[_key3];
      }

      var diagram = _construct(Diagram, items);

      diagram.items[0] = new Start({
        type: "complex"
      });
      diagram.items[diagram.items.length - 1] = new End({
        type: "complex"
      });
      return _possibleConstructorReturn(_this4, diagram);
    }

    _createClass(ComplexDiagram, null, [{
      key: "fromJSON",
      value: function fromJSON() {
        var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return diagramFromJSON(ComplexDiagram, input);
      }
    }]);

    return ComplexDiagram;
  }(FakeSVG);

  funcs.ComplexDiagram = function () {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return _construct(ComplexDiagram, args);
  };

  funcs.ComplexDiagram.fromJSON = ComplexDiagram.fromJSON;

  var Sequence = /*#__PURE__*/function (_DiagramMultiContaine2) {
    _inherits(Sequence, _DiagramMultiContaine2);

    var _super5 = _createSuper(Sequence);

    function Sequence() {
      var _this5;

      _classCallCheck(this, Sequence);

      for (var _len5 = arguments.length, items = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        items[_key5] = arguments[_key5];
      }

      _this5 = _super5.call(this, 'g', items);
      var numberOfItems = _this5.items.length;
      _this5.needsSpace = true;
      _this5.up = _this5.down = _this5.height = _this5.width = 0;

      for (var i = 0; i < numberOfItems; i++) {
        var item = _this5.items[i];
        _this5.width += item.width + (item.needsSpace ? 20 : 0);
        _this5.up = Math.max(_this5.up, item.up - _this5.height);
        _this5.height += item.height;
        _this5.down = Math.max(_this5.down - item.height, item.down);
      }

      if (_this5.items[0].needsSpace) _this5.width -= 10;
      if (_this5.items[numberOfItems - 1].needsSpace) _this5.width -= 10;

      if (Options.DEBUG) {
        _this5.attrs['data-updown'] = _this5.up + " " + _this5.height + " " + _this5.down;
        _this5.attrs['data-type'] = "sequence";
      }

      return _this5;
    }

    _createClass(Sequence, [{
      key: "format",
      value: function format(x, y, width) {
        var gaps = determineGaps(width, this.width);
        new Path(x, y).h(gaps[0]).addTo(this);
        new Path(x + gaps[0] + this.width, y + this.height).h(gaps[1]).addTo(this);
        x += gaps[0];

        for (var i = 0; i < this.items.length; i++) {
          var item = this.items[i];

          if (item.needsSpace && i > 0) {
            new Path(x, y).h(10).addTo(this);
            x += 10;
          }

          item.format(x, y, item.width).addTo(this);
          x += item.width;
          y += item.height;

          if (item.needsSpace && i < this.items.length - 1) {
            new Path(x, y).h(10).addTo(this);
            x += 10;
          }
        }

        return this;
      }
    }]);

    return Sequence;
  }(DiagramMultiContainer);

  funcs.Sequence = function () {
    for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      args[_key6] = arguments[_key6];
    }

    return _construct(Sequence, args);
  };

  var Stack = /*#__PURE__*/function (_DiagramMultiContaine3) {
    _inherits(Stack, _DiagramMultiContaine3);

    var _super6 = _createSuper(Stack);

    function Stack() {
      var _this6;

      _classCallCheck(this, Stack);

      for (var _len7 = arguments.length, items = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        items[_key7] = arguments[_key7];
      }

      _this6 = _super6.call(this, 'g', items);

      if (items.length === 0) {
        throw new RangeError("Stack() must have at least one child.");
      }

      _this6.width = Math.max.apply(null, _this6.items.map(function (e) {
        return e.width + (e.needsSpace ? 20 : 0);
      }));

      if (_this6.items.length > 1) {
        _this6.width += Options.AR * 2;
      }

      _this6.needsSpace = true;
      _this6.up = _this6.items[0].up;
      _this6.down = _this6.items[_this6.items.length - 1].down;
      _this6.height = 0;
      var last = _this6.items.length - 1;

      for (var i = 0; i < _this6.items.length; i++) {
        var item = _this6.items[i];
        _this6.height += item.height;

        if (i > 0) {
          _this6.height += Math.max(Options.AR * 2, item.up + Options.VS);
        }

        if (i < last) {
          _this6.height += Math.max(Options.AR * 2, item.down + Options.VS);
        }
      }

      if (Options.DEBUG) {
        _this6.attrs['data-updown'] = _this6.up + " " + _this6.height + " " + _this6.down;
        _this6.attrs['data-type'] = "stack";
      }

      return _this6;
    }

    _createClass(Stack, [{
      key: "format",
      value: function format(x, y, width) {
        var gaps = determineGaps(width, this.width);
        new Path(x, y).h(gaps[0]).addTo(this);
        x += gaps[0];
        var xInitial = x;

        if (this.items.length > 1) {
          new Path(x, y).h(Options.AR).addTo(this);
          x += Options.AR;
        }

        for (var i = 0; i < this.items.length; i++) {
          var item = this.items[i];
          var innerWidth = this.width - (this.items.length > 1 ? Options.AR * 2 : 0);
          item.format(x, y, innerWidth).addTo(this);
          x += innerWidth;
          y += item.height;

          if (i !== this.items.length - 1) {
            new Path(x, y).arc('ne').down(Math.max(0, item.down + Options.VS - Options.AR * 2)).arc('es').left(innerWidth).arc('nw').down(Math.max(0, this.items[i + 1].up + Options.VS - Options.AR * 2)).arc('ws').addTo(this);
            y += Math.max(item.down + Options.VS, Options.AR * 2) + Math.max(this.items[i + 1].up + Options.VS, Options.AR * 2);
            x = xInitial + Options.AR;
          }
        }

        if (this.items.length > 1) {
          new Path(x, y).h(Options.AR).addTo(this);
          x += Options.AR;
        }

        new Path(x, y).h(gaps[1]).addTo(this);
        return this;
      }
    }]);

    return Stack;
  }(DiagramMultiContainer);

  funcs.Stack = function () {
    for (var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
      args[_key8] = arguments[_key8];
    }

    return _construct(Stack, args);
  };

  var VerticalSequence = /*#__PURE__*/function (_DiagramMultiContaine4) {
    _inherits(VerticalSequence, _DiagramMultiContaine4);

    var _super7 = _createSuper(VerticalSequence);

    function VerticalSequence() {
      var _this7;

      _classCallCheck(this, VerticalSequence);

      for (var _len9 = arguments.length, items = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
        items[_key9] = arguments[_key9];
      }

      _this7 = _super7.call(this, 'g', items);

      if (items.length === 0) {
        throw new RangeError("VerticalSequence() must have at least one child.");
      }

      _this7.items = items.map(wrapString);
      _this7.width = Math.max.apply(null, _this7.items.map(function (e) {
        return e.width + (e.needsSpace ? 20 : 0);
      }));

      if (_this7.items.length > 1) {
        _this7.width += Options.AR * 2;
      }

      _this7.needsSpace = true;
      _this7.up = _this7.items[0].up;
      _this7.down = _this7.items[_this7.items.length - 1].down;
      _this7.height = 0;
      var last = _this7.items.length - 1;

      for (var i = 0; i < _this7.items.length; i++) {
        if (i !== last) {
          _this7.height += _this7.items[i].height + _this7.items[i].down + _this7.items[i + 1].up + Options.VS * 2;
        }
      }

      if (Options.DEBUG) {
        _this7.attrs['data-updown'] = _this7.up + " " + _this7.height + " " + _this7.down;
        _this7.attrs['data-type'] = "verticalsequence";
      }

      return _this7;
    }

    _createClass(VerticalSequence, [{
      key: "format",
      value: function format(x, y, width) {
        var gaps = determineGaps(width, this.width);
        new Path(x, y).h(gaps[0]).addTo(this);
        x += gaps[0];
        var xInitial = x;
        var minWidth = 1000;

        for (var itemNum in this.items) {
          var _item = this.items[itemNum];
          minWidth = _item.width < minWidth ? _item.width : minWidth;
        }

        for (var i = 0; i < this.items.length; i++) {
          var item = this.items[i];
          item.format(x, y, item.width).addTo(this);
          y += item.height;

          if (i !== this.items.length - 1) {
            x += minWidth / 2;
            y += item.down;
            new Path(x, y).v(Options.VS * 2).addTo(this);
            y += this.items[i + 1].up + Options.VS * 2;
            x = xInitial;
          } else {
            x += item.width;
            y += item.height;
          }
        }

        if (this.items.length > 1) {
          new Path(x, y).h(this.width - this.items[this.items.length - 1].width).addTo(this);
          x += Options.AR;
        }

        new Path(x, y).h(gaps[1]).addTo(this);
        return this;
      }
    }]);

    return VerticalSequence;
  }(DiagramMultiContainer);

  funcs.VerticalSequence = function () {
    for (var _len10 = arguments.length, args = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
      args[_key10] = arguments[_key10];
    }

    return _construct(VerticalSequence, args);
  };

  var OptionalSequence = /*#__PURE__*/function (_DiagramMultiContaine5) {
    _inherits(OptionalSequence, _DiagramMultiContaine5);

    var _super8 = _createSuper(OptionalSequence);

    function OptionalSequence() {
      var _this8;

      _classCallCheck(this, OptionalSequence);

      for (var _len11 = arguments.length, items = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
        items[_key11] = arguments[_key11];
      }

      _this8 = _super8.call(this, 'g', items);

      if (items.length === 0) {
        throw new RangeError("OptionalSequence() must have at least one child.");
      }

      if (items.length === 1) {
        return _possibleConstructorReturn(_this8, new Sequence(items));
      }

      var arc = Options.AR;
      _this8.needsSpace = false;
      _this8.width = 0;
      _this8.up = 0;
      _this8.height = sum(_this8.items, function (x) {
        return x.height;
      });
      _this8.down = _this8.items[0].down;
      var heightSoFar = 0;

      for (var i = 0; i < _this8.items.length; i++) {
        var item = _this8.items[i];
        _this8.up = Math.max(_this8.up, Math.max(arc * 2, item.up + Options.VS) - heightSoFar);
        heightSoFar += item.height;

        if (i > 0) {
          _this8.down = Math.max(_this8.height + _this8.down, heightSoFar + Math.max(arc * 2, item.down + Options.VS)) - _this8.height;
        }

        var itemWidth = (item.needsSpace ? 10 : 0) + item.width;

        if (i === 0) {
          _this8.width += arc + Math.max(itemWidth, arc);
        } else {
          _this8.width += arc * 2 + Math.max(itemWidth, arc) + arc;
        }
      }

      if (Options.DEBUG) {
        _this8.attrs['data-updown'] = _this8.up + " " + _this8.height + " " + _this8.down;
        _this8.attrs['data-type'] = "optseq";
      }

      return _this8;
    }

    _createClass(OptionalSequence, [{
      key: "format",
      value: function format(x, y, width) {
        var arc = Options.AR;
        var gaps = determineGaps(width, this.width);
        new Path(x, y).right(gaps[0]).addTo(this);
        new Path(x + gaps[0] + this.width, y + this.height).right(gaps[1]).addTo(this);
        x += gaps[0];
        var upperLineY = y - this.up;
        var last = this.items.length - 1;

        for (var i = 0; i < this.items.length; i++) {
          var item = this.items[i];
          var itemSpace = item.needsSpace ? 10 : 0;
          var itemWidth = item.width + itemSpace;

          if (i === 0) {
            new Path(x, y).arc('se').up(y - upperLineY - arc * 2).arc('wn').right(itemWidth - arc).arc('ne').down(y + item.height - upperLineY - arc * 2).arc('ws').addTo(this);
            new Path(x, y).right(itemSpace + arc).addTo(this);
            item.format(x + itemSpace + arc, y, item.width).addTo(this);
            x += itemWidth + arc;
            y += item.height;
          } else if (i < last) {
            new Path(x, upperLineY).right(arc * 2 + Math.max(itemWidth, arc) + arc).arc('ne').down(y - upperLineY + item.height - arc * 2).arc('ws').addTo(this);
            new Path(x, y).right(arc * 2).addTo(this);
            item.format(x + arc * 2, y, item.width).addTo(this);
            new Path(x + item.width + arc * 2, y + item.height).right(itemSpace + arc).addTo(this);
            new Path(x, y).arc('ne').down(item.height + Math.max(item.down + Options.VS, arc * 2) - arc * 2).arc('ws').right(itemWidth - arc).arc('se').up(item.down + Options.VS - arc * 2).arc('wn').addTo(this);
            x += arc * 2 + Math.max(itemWidth, arc) + arc;
            y += item.height;
          } else {
            new Path(x, y).right(arc * 2).addTo(this);
            item.format(x + arc * 2, y, item.width).addTo(this);
            new Path(x + arc * 2 + item.width, y + item.height).right(itemSpace + arc).addTo(this);
            new Path(x, y).arc('ne').down(item.height + Math.max(item.down + Options.VS, arc * 2) - arc * 2).arc('ws').right(itemWidth - arc).arc('se').up(item.down + Options.VS - arc * 2).arc('wn').addTo(this);
          }
        }

        return this;
      }
    }]);

    return OptionalSequence;
  }(DiagramMultiContainer);

  funcs.OptionalSequence = function () {
    for (var _len12 = arguments.length, args = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
      args[_key12] = arguments[_key12];
    }

    return _construct(OptionalSequence, args);
  };

  var AlternatingSequence = /*#__PURE__*/function (_DiagramMultiContaine6) {
    _inherits(AlternatingSequence, _DiagramMultiContaine6);

    var _super9 = _createSuper(AlternatingSequence);

    function AlternatingSequence() {
      var _this9;

      _classCallCheck(this, AlternatingSequence);

      for (var _len13 = arguments.length, items = new Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
        items[_key13] = arguments[_key13];
      }

      _this9 = _super9.call(this, 'g', items);

      if (items.length === 1) {
        return _possibleConstructorReturn(_this9, new Sequence(items));
      }

      if (items.length !== 2) {
        throw new RangeError("AlternatingSequence() must have one or two children.");
      }

      _this9.needsSpace = false;
      var arc = Options.AR;
      var vert = Options.VS;
      var max = Math.max;
      var first = _this9.items[0];
      var second = _this9.items[1];
      var arcX = 1 / Math.sqrt(2) * arc * 2;
      var arcY = (1 - 1 / Math.sqrt(2)) * arc * 2;
      var crossY = Math.max(arc, Options.VS);
      var crossX = crossY - arcY + arcX;
      var firstOut = max(arc + arc, crossY / 2 + arc + arc, crossY / 2 + vert + first.down);
      _this9.up = firstOut + first.height + first.up;
      var secondIn = max(arc + arc, crossY / 2 + arc + arc, crossY / 2 + vert + second.up);
      _this9.down = secondIn + second.height + second.down;
      _this9.height = 0;
      var firstWidth = 2 * (first.needsSpace ? 10 : 0) + first.width;
      var secondWidth = 2 * (second.needsSpace ? 10 : 0) + second.width;
      _this9.width = 2 * arc + max(firstWidth, crossX, secondWidth) + 2 * arc;

      if (Options.DEBUG) {
        _this9.attrs['data-updown'] = _this9.up + " " + _this9.height + " " + _this9.down;
        _this9.attrs['data-type'] = "altseq";
      }

      return _this9;
    }

    _createClass(AlternatingSequence, [{
      key: "format",
      value: function format(x, y, width) {
        var arc = Options.AR;
        var gaps = determineGaps(width, this.width);
        new Path(x, y).right(gaps[0]).addTo(this);
        x += gaps[0];
        new Path(x + this.width, y).right(gaps[1]).addTo(this);
        var first = this.items[0];
        var second = this.items[1];
        var firstIn = this.up - first.up;
        var firstOut = this.up - first.up - first.height;
        new Path(x, y).arc('se').up(firstIn - 2 * arc).arc('wn').addTo(this);
        first.format(x + 2 * arc, y - firstIn, this.width - 4 * arc).addTo(this);
        new Path(x + this.width - 2 * arc, y - firstOut).arc('ne').down(firstOut - 2 * arc).arc('ws').addTo(this);
        var secondIn = this.down - second.down - second.height;
        var secondOut = this.down - second.down;
        new Path(x, y).arc('ne').down(secondIn - 2 * arc).arc('ws').addTo(this);
        second.format(x + 2 * arc, y + secondIn, this.width - 4 * arc).addTo(this);
        new Path(x + this.width - 2 * arc, y + secondOut).arc('se').up(secondOut - 2 * arc).arc('wn').addTo(this);
        var arcX = 1 / Math.sqrt(2) * arc * 2;
        var arcY = (1 - 1 / Math.sqrt(2)) * arc * 2;
        var crossY = Math.max(arc, Options.VS);
        var crossX = crossY - arcY + arcX;
        var crossBar = (this.width - 4 * arc - crossX) / 2;
        new Path(x + arc, y - crossY / 2 - arc).arc('ws').right(crossBar).arc_8('n', 'cw').l(crossX - arcX, crossY - arcY).arc_8('sw', 'ccw').right(crossBar).arc('ne').addTo(this);
        new Path(x + arc, y + crossY / 2 + arc).arc('wn').right(crossBar).arc_8('s', 'ccw').l(crossX - arcX, -(crossY - arcY)).arc_8('nw', 'cw').right(crossBar).arc('se').addTo(this);
        return this;
      }
    }]);

    return AlternatingSequence;
  }(DiagramMultiContainer);

  funcs.AlternatingSequence = function () {
    for (var _len14 = arguments.length, args = new Array(_len14), _key14 = 0; _key14 < _len14; _key14++) {
      args[_key14] = arguments[_key14];
    }

    return _construct(AlternatingSequence, args);
  };

  var Choice = /*#__PURE__*/function (_DiagramMultiContaine7) {
    _inherits(Choice, _DiagramMultiContaine7);

    var _super10 = _createSuper(Choice);

    function Choice(normal) {
      var _this10;

      _classCallCheck(this, Choice);

      for (var _len15 = arguments.length, items = new Array(_len15 > 1 ? _len15 - 1 : 0), _key15 = 1; _key15 < _len15; _key15++) {
        items[_key15 - 1] = arguments[_key15];
      }

      _this10 = _super10.call(this, 'g', items);

      if (typeof normal !== "number" || normal !== Math.floor(normal)) {
        throw new TypeError("The first argument of Choice() must be an integer.");
      } else if (normal < 0 || normal >= items.length) {
        throw new RangeError("The first argument of Choice() must be an index for one of the items.");
      } else {
        _this10.normal = normal;
      }

      var first = 0;
      var last = items.length - 1;
      _this10.width = Math.max.apply(null, _this10.items.map(function (el) {
        return el.width;
      })) + Options.AR * 4;
      _this10.height = _this10.items[normal].height;
      _this10.up = _this10.items[first].up;
      var arcs;

      for (var i = first; i < normal; i++) {
        if (i == normal - 1) arcs = Options.AR * 2;else arcs = Options.AR;
        _this10.up += Math.max(arcs, _this10.items[i].height + _this10.items[i].down + Options.VS + _this10.items[i + 1].up);
      }

      _this10.down = _this10.items[last].down;

      for (i = normal + 1; i <= last; i++) {
        if (i == normal + 1) arcs = Options.AR * 2;else arcs = Options.AR;
        _this10.down += Math.max(arcs, _this10.items[i - 1].height + _this10.items[i - 1].down + Options.VS + _this10.items[i].up);
      }

      _this10.down -= _this10.items[normal].height;

      if (Options.DEBUG) {
        _this10.attrs['data-updown'] = _this10.up + " " + _this10.height + " " + _this10.down;
        _this10.attrs['data-type'] = "choice";
      }

      return _this10;
    }

    _createClass(Choice, [{
      key: "format",
      value: function format(x, y, width) {
        var gaps = determineGaps(width, this.width);
        new Path(x, y).h(gaps[0]).addTo(this);
        new Path(x + gaps[0] + this.width, y + this.height).h(gaps[1]).addTo(this);
        x += gaps[0];
        var last = this.items.length - 1;
        var innerWidth = this.width - Options.AR * 4;
        var distanceFromY;

        for (var i = this.normal - 1; i >= 0; i--) {
          var item = this.items[i];

          if (i == this.normal - 1) {
            distanceFromY = Math.max(Options.AR * 2, this.items[this.normal].up + Options.VS + item.down + item.height);
          }

          new Path(x, y).arc('se').up(distanceFromY - Options.AR * 2).arc('wn').addTo(this);
          item.format(x + Options.AR * 2, y - distanceFromY, innerWidth).addTo(this);
          new Path(x + Options.AR * 2 + innerWidth, y - distanceFromY + item.height).arc('ne').down(distanceFromY - item.height + this.height - Options.AR * 2).arc('ws').addTo(this);
          distanceFromY += Math.max(Options.AR, item.up + Options.VS + (i === 0 ? 0 : this.items[i - 1].down + this.items[i - 1].height));
        }

        new Path(x, y).right(Options.AR * 2).addTo(this);
        this.items[this.normal].format(x + Options.AR * 2, y, innerWidth).addTo(this);
        new Path(x + Options.AR * 2 + innerWidth, y + this.height).right(Options.AR * 2).addTo(this);

        for (i = this.normal + 1; i <= last; i++) {
          var _item2 = this.items[i];

          if (i == this.normal + 1) {
            distanceFromY = Math.max(Options.AR * 2, this.height + this.items[this.normal].down + Options.VS + _item2.up);
          }

          new Path(x, y).arc('ne').down(distanceFromY - Options.AR * 2).arc('ws').addTo(this);

          _item2.format(x + Options.AR * 2, y + distanceFromY, innerWidth).addTo(this);

          new Path(x + Options.AR * 2 + innerWidth, y + distanceFromY + _item2.height).arc('se').up(distanceFromY - Options.AR * 2 + _item2.height - this.height).arc('wn').addTo(this);
          distanceFromY += Math.max(Options.AR, _item2.height + _item2.down + Options.VS + (i == last ? 0 : this.items[i + 1].up));
        }

        return this;
      }
    }]);

    return Choice;
  }(DiagramMultiContainer);

  funcs.Choice = function () {
    for (var _len16 = arguments.length, args = new Array(_len16), _key16 = 0; _key16 < _len16; _key16++) {
      args[_key16] = arguments[_key16];
    }

    return _construct(Choice, args);
  };

  var HorizontalChoice = /*#__PURE__*/function (_DiagramMultiContaine8) {
    _inherits(HorizontalChoice, _DiagramMultiContaine8);

    var _super11 = _createSuper(HorizontalChoice);

    function HorizontalChoice() {
      var _this11;

      _classCallCheck(this, HorizontalChoice);

      for (var _len17 = arguments.length, items = new Array(_len17), _key17 = 0; _key17 < _len17; _key17++) {
        items[_key17] = arguments[_key17];
      }

      _this11 = _super11.call(this, 'g', items);

      if (items.length === 0) {
        throw new RangeError("HorizontalChoice() must have at least one child.");
      }

      if (items.length === 1) {
        return _possibleConstructorReturn(_this11, new Sequence(items));
      }

      var allButLast = _this11.items.slice(0, -1);

      var middles = _this11.items.slice(1, -1);

      var first = _this11.items[0];
      var last = _this11.items[_this11.items.length - 1];
      _this11.needsSpace = false;
      _this11.width = Options.AR;
      _this11.width += Options.AR * 2 * (_this11.items.length - 1);
      _this11.width += sum(_this11.items, function (x) {
        return x.width + (x.needsSpace ? 20 : 0);
      });
      _this11.width += last.height > 0 ? Options.AR : 0;
      _this11.width += Options.AR;
      _this11.height = 0;
      _this11._upperTrack = Math.max(Options.AR * 2, Options.VS, max(allButLast, function (x) {
        return x.up;
      }) + Options.VS);
      _this11.up = Math.max(_this11._upperTrack, last.up);
      _this11._lowerTrack = Math.max(Options.VS, max(middles, function (x) {
        return x.height + Math.max(x.down + Options.VS, Options.AR * 2);
      }), last.height + last.down + Options.VS);

      if (first.height < _this11._lowerTrack) {
        _this11._lowerTrack = Math.max(_this11._lowerTrack, first.height + Options.AR * 2);
      }

      _this11.down = Math.max(_this11._lowerTrack, first.height + first.down);

      if (Options.DEBUG) {
        _this11.attrs['data-updown'] = _this11.up + " " + _this11.height + " " + _this11.down;
        _this11.attrs['data-type'] = "horizontalchoice";
      }

      return _this11;
    }

    _createClass(HorizontalChoice, [{
      key: "format",
      value: function format(x, y, width) {
        var gaps = determineGaps(width, this.width);
        new Path(x, y).h(gaps[0]).addTo(this);
        new Path(x + gaps[0] + this.width, y + this.height).h(gaps[1]).addTo(this);
        x += gaps[0];
        var first = this.items[0];
        var last = this.items[this.items.length - 1];
        var allButFirst = this.items.slice(1);
        var allButLast = this.items.slice(0, -1);
        var upperSpan = sum(allButLast, function (x) {
          return x.width + (x.needsSpace ? 20 : 0);
        }) + (this.items.length - 2) * Options.AR * 2 - Options.AR;
        new Path(x, y).arc('se').v(-(this._upperTrack - Options.AR * 2)).arc('wn').h(upperSpan).addTo(this);
        var lowerSpan = sum(allButFirst, function (x) {
          return x.width + (x.needsSpace ? 20 : 0);
        }) + (this.items.length - 2) * Options.AR * 2 + (last.height > 0 ? Options.AR : 0) - Options.AR;
        var lowerStart = x + Options.AR + first.width + (first.needsSpace ? 20 : 0) + Options.AR * 2;
        new Path(lowerStart, y + this._lowerTrack).h(lowerSpan).arc('se').v(-(this._lowerTrack - Options.AR * 2)).arc('wn').addTo(this);

        var _iterator2 = _createForOfIteratorHelper(enumerate(this.items)),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _step2$value = _slicedToArray(_step2.value, 2),
                i = _step2$value[0],
                item = _step2$value[1];

            if (i === 0) {
              new Path(x, y).h(Options.AR).addTo(this);
              x += Options.AR;
            } else {
              new Path(x, y - this._upperTrack).arc('ne').v(this._upperTrack - Options.AR * 2).arc('ws').addTo(this);
              x += Options.AR * 2;
            }

            var itemWidth = item.width + (item.needsSpace ? 20 : 0);
            item.format(x, y, itemWidth).addTo(this);
            x += itemWidth;

            if (i === this.items.length - 1) {
              if (item.height === 0) {
                new Path(x, y).h(Options.AR).addTo(this);
              } else {
                new Path(x, y + item.height).arc('se').addTo(this);
              }
            } else if (i === 0 && item.height > this._lowerTrack) {
              if (item.height - this._lowerTrack >= Options.AR * 2) {
                new Path(x, y + item.height).arc('se').v(this._lowerTrack - item.height + Options.AR * 2).arc('wn').addTo(this);
              } else {
                new Path(x, y + item.height).l(Options.AR * 2, this._lowerTrack - item.height).addTo(this);
              }
            } else {
              new Path(x, y + item.height).arc('ne').v(this._lowerTrack - item.height - Options.AR * 2).arc('ws').addTo(this);
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        return this;
      }
    }]);

    return HorizontalChoice;
  }(DiagramMultiContainer);

  funcs.HorizontalChoice = function () {
    for (var _len18 = arguments.length, args = new Array(_len18), _key18 = 0; _key18 < _len18; _key18++) {
      args[_key18] = arguments[_key18];
    }

    return _construct(HorizontalChoice, args);
  };

  var MultipleChoice = /*#__PURE__*/function (_DiagramMultiContaine9) {
    _inherits(MultipleChoice, _DiagramMultiContaine9);

    var _super12 = _createSuper(MultipleChoice);

    function MultipleChoice(normal, type) {
      var _this12;

      _classCallCheck(this, MultipleChoice);

      for (var _len19 = arguments.length, items = new Array(_len19 > 2 ? _len19 - 2 : 0), _key19 = 2; _key19 < _len19; _key19++) {
        items[_key19 - 2] = arguments[_key19];
      }

      _this12 = _super12.call(this, 'g', items);

      if (typeof normal !== "number" || normal !== Math.floor(normal)) {
        throw new TypeError("The first argument of MultipleChoice() must be an integer.");
      } else if (normal < 0 || normal >= items.length) {
        throw new RangeError("The first argument of MultipleChoice() must be an index for one of the items.");
      } else {
        _this12.normal = normal;
      }

      if (type != "any" && type != "all") {
        throw new SyntaxError("The second argument of MultipleChoice must be 'any' or 'all'.");
      } else {
        _this12.type = type;
      }

      _this12.needsSpace = true;
      _this12.innerWidth = max(_this12.items, function (x) {
        return x.width;
      });
      _this12.width = 30 + Options.AR + _this12.innerWidth + Options.AR + 20;
      _this12.up = _this12.items[0].up;
      _this12.down = _this12.items[_this12.items.length - 1].down;
      _this12.height = _this12.items[normal].height;

      for (var i = 0; i < _this12.items.length; i++) {
        var item = _this12.items[i];
        var minimum = void 0;
        if (i == normal - 1 || i == normal + 1) minimum = 10 + Options.AR;else minimum = Options.AR;

        if (i < normal) {
          _this12.up += Math.max(minimum, item.height + item.down + Options.VS + _this12.items[i + 1].up);
        } else if (i > normal) {
          _this12.down += Math.max(minimum, item.up + Options.VS + _this12.items[i - 1].down + _this12.items[i - 1].height);
        }
      }

      _this12.down -= _this12.items[normal].height;

      if (Options.DEBUG) {
        _this12.attrs['data-updown'] = _this12.up + " " + _this12.height + " " + _this12.down;
        _this12.attrs['data-type'] = "multiplechoice";
      }

      return _this12;
    }

    _createClass(MultipleChoice, [{
      key: "format",
      value: function format(x, y, width) {
        var gaps = determineGaps(width, this.width);
        new Path(x, y).right(gaps[0]).addTo(this);
        new Path(x + gaps[0] + this.width, y + this.height).right(gaps[1]).addTo(this);
        x += gaps[0];
        var normal = this.items[this.normal];
        var distanceFromY;

        for (var i = this.normal - 1; i >= 0; i--) {
          var item = this.items[i];

          if (i == this.normal - 1) {
            distanceFromY = Math.max(10 + Options.AR, normal.up + Options.VS + item.down + item.height);
          }

          new Path(x + 30, y).up(distanceFromY - Options.AR).arc('wn').addTo(this);
          item.format(x + 30 + Options.AR, y - distanceFromY, this.innerWidth).addTo(this);
          new Path(x + 30 + Options.AR + this.innerWidth, y - distanceFromY + item.height).arc('ne').down(distanceFromY - item.height + this.height - Options.AR - 10).addTo(this);

          if (i !== 0) {
            distanceFromY += Math.max(Options.AR, item.up + Options.VS + this.items[i - 1].down + this.items[i - 1].height);
          }
        }

        new Path(x + 30, y).right(Options.AR).addTo(this);
        normal.format(x + 30 + Options.AR, y, this.innerWidth).addTo(this);
        new Path(x + 30 + Options.AR + this.innerWidth, y + this.height).right(Options.AR).addTo(this);

        for (i = this.normal + 1; i < this.items.length; i++) {
          var _item3 = this.items[i];

          if (i == this.normal + 1) {
            distanceFromY = Math.max(10 + Options.AR, normal.height + normal.down + Options.VS + _item3.up);
          }

          new Path(x + 30, y).down(distanceFromY - Options.AR).arc('ws').addTo(this);

          _item3.format(x + 30 + Options.AR, y + distanceFromY, this.innerWidth).addTo(this);

          new Path(x + 30 + Options.AR + this.innerWidth, y + distanceFromY + _item3.height).arc('se').up(distanceFromY - Options.AR + _item3.height - normal.height).addTo(this);

          if (i != this.items.length - 1) {
            distanceFromY += Math.max(Options.AR, _item3.height + _item3.down + Options.VS + this.items[i + 1].up);
          }
        }

        var text = new FakeSVG('g', {
          "class": "diagram-text"
        }).addTo(this);
        new FakeSVG('title', {}, this.type == "any" ? "take one or more branches, once each, in any order" : "take all branches, once each, in any order").addTo(text);
        new FakeSVG('path', {
          "d": "M " + (x + 30) + " " + (y - 10) + " h -26 a 4 4 0 0 0 -4 4 v 12 a 4 4 0 0 0 4 4 h 26 z",
          "class": "diagram-text"
        }).addTo(text);
        new FakeSVG('text', {
          "x": x + 15,
          "y": y + 4,
          "class": "diagram-text"
        }, this.type == "any" ? "1+" : "all").addTo(text);
        new FakeSVG('path', {
          "d": "M " + (x + this.width - 20) + " " + (y - 10) + " h 16 a 4 4 0 0 1 4 4 v 12 a 4 4 0 0 1 -4 4 h -16 z",
          "class": "diagram-text"
        }).addTo(text);
        new FakeSVG('path', {
          "d": "M " + (x + this.width - 13) + " " + (y - 2) + " a 4 4 0 1 0 6 -1 m 2.75 -1 h -4 v 4 m 0 -3 h 2",
          "style": "stroke-width: 1.75"
        }).addTo(text);
        return this;
      }
    }]);

    return MultipleChoice;
  }(DiagramMultiContainer);

  funcs.MultipleChoice = function () {
    for (var _len20 = arguments.length, args = new Array(_len20), _key20 = 0; _key20 < _len20; _key20++) {
      args[_key20] = arguments[_key20];
    }

    return _construct(MultipleChoice, args);
  };

  var Optional = /*#__PURE__*/function (_FakeSVG4) {
    _inherits(Optional, _FakeSVG4);

    var _super13 = _createSuper(Optional);

    function Optional(item, skip) {
      var _this13;

      _classCallCheck(this, Optional);

      if (skip === undefined) return _possibleConstructorReturn(_this13, new Choice(1, new Skip(), item));else if (skip === "skip") return _possibleConstructorReturn(_this13, new Choice(0, new Skip(), item));else throw "Unknown value for Optional()'s 'skip' argument.";
      return _possibleConstructorReturn(_this13);
    }

    return Optional;
  }(FakeSVG);

  funcs.Optional = function () {
    for (var _len21 = arguments.length, args = new Array(_len21), _key21 = 0; _key21 < _len21; _key21++) {
      args[_key21] = arguments[_key21];
    }

    return _construct(Optional, args);
  };

  var OneOrMore = /*#__PURE__*/function (_FakeSVG5) {
    _inherits(OneOrMore, _FakeSVG5);

    var _super14 = _createSuper(OneOrMore);

    function OneOrMore(item, rep) {
      var _this14;

      _classCallCheck(this, OneOrMore);

      _this14 = _super14.call(this, 'g');
      rep = rep || new Skip();
      _this14.item = wrapString(item);
      _this14.rep = wrapString(rep);
      _this14.width = Math.max(_this14.item.width, _this14.rep.width) + Options.AR * 2;
      _this14.height = _this14.item.height;
      _this14.up = _this14.item.up;
      _this14.down = Math.max(Options.AR * 2, _this14.item.down + Options.VS + _this14.rep.up + _this14.rep.height + _this14.rep.down);
      _this14.needsSpace = true;

      if (Options.DEBUG) {
        _this14.attrs['data-updown'] = _this14.up + " " + _this14.height + " " + _this14.down;
        _this14.attrs['data-type'] = "oneormore";
      }

      return _this14;
    }

    _createClass(OneOrMore, [{
      key: "format",
      value: function format(x, y, width) {
        var gaps = determineGaps(width, this.width);
        new Path(x, y).h(gaps[0]).addTo(this);
        new Path(x + gaps[0] + this.width, y + this.height).h(gaps[1]).addTo(this);
        x += gaps[0];
        new Path(x, y).right(Options.AR).addTo(this);
        this.item.format(x + Options.AR, y, this.width - Options.AR * 2).addTo(this);
        new Path(x + this.width - Options.AR, y + this.height).right(Options.AR).addTo(this);
        var distanceFromY = Math.max(Options.AR * 2, this.item.height + this.item.down + Options.VS + this.rep.up);
        new Path(x + Options.AR, y).arc('nw').down(distanceFromY - Options.AR * 2).arc('ws').addTo(this);
        this.rep.format(x + Options.AR, y + distanceFromY, this.width - Options.AR * 2).addTo(this);
        new Path(x + this.width - Options.AR, y + distanceFromY + this.rep.height).arc('se').up(distanceFromY - Options.AR * 2 + this.rep.height - this.item.height).arc('en').addTo(this);
        return this;
      }
    }, {
      key: "walk",
      value: function walk(cb) {
        cb(this);
        this.item.walk(cb);
        this.rep.walk(cb);
      }
    }]);

    return OneOrMore;
  }(FakeSVG);

  funcs.OneOrMore = function () {
    for (var _len22 = arguments.length, args = new Array(_len22), _key22 = 0; _key22 < _len22; _key22++) {
      args[_key22] = arguments[_key22];
    }

    return _construct(OneOrMore, args);
  };

  var ZeroOrMore = /*#__PURE__*/function (_FakeSVG6) {
    _inherits(ZeroOrMore, _FakeSVG6);

    var _super15 = _createSuper(ZeroOrMore);

    function ZeroOrMore(item, rep, skip) {
      var _this15;

      _classCallCheck(this, ZeroOrMore);

      return _possibleConstructorReturn(_this15, new Optional(new OneOrMore(item, rep), skip));
    }

    return ZeroOrMore;
  }(FakeSVG);

  funcs.ZeroOrMore = function () {
    for (var _len23 = arguments.length, args = new Array(_len23), _key23 = 0; _key23 < _len23; _key23++) {
      args[_key23] = arguments[_key23];
    }

    return _construct(ZeroOrMore, args);
  };

  var Group = /*#__PURE__*/function (_FakeSVG7) {
    _inherits(Group, _FakeSVG7);

    var _super16 = _createSuper(Group);

    function Group(item, label) {
      var _this16;

      _classCallCheck(this, Group);

      _this16 = _super16.call(this, 'g');
      _this16.item = wrapString(item);
      _this16.label = label instanceof FakeSVG ? label : label ? new Comment(label) : undefined;
      _this16.width = Math.max(_this16.item.width + (_this16.item.needsSpace ? 20 : 0), _this16.label ? _this16.label.width : 0, Options.AR * 2);
      _this16.height = _this16.item.height;
      _this16.boxUp = _this16.up = Math.max(_this16.item.up + Options.VS, Options.AR);

      if (_this16.label) {
        _this16.up += _this16.label.up + _this16.label.height + _this16.label.down;
      }

      _this16.down = Math.max(_this16.item.down + Options.VS, Options.AR);
      _this16.needsSpace = true;

      if (Options.DEBUG) {
        _this16.attrs['data-updown'] = _this16.up + " " + _this16.height + " " + _this16.down;
        _this16.attrs['data-type'] = "group";
      }

      return _this16;
    }

    _createClass(Group, [{
      key: "format",
      value: function format(x, y, width) {
        var gaps = determineGaps(width, this.width);
        new Path(x, y).h(gaps[0]).addTo(this);
        new Path(x + gaps[0] + this.width, y + this.height).h(gaps[1]).addTo(this);
        x += gaps[0];
        new FakeSVG('rect', {
          x: x,
          y: y - this.boxUp,
          width: this.width,
          height: this.boxUp + this.height + this.down,
          rx: Options.AR,
          ry: Options.AR,
          'class': 'group-box'
        }).addTo(this);
        this.item.format(x, y, this.width).addTo(this);

        if (this.label) {
          this.label.format(x, y - (this.boxUp + this.label.down + this.label.height), this.label.width).addTo(this);
        }

        return this;
      }
    }, {
      key: "walk",
      value: function walk(cb) {
        cb(this);
        this.item.walk(cb);
        this.label.walk(cb);
      }
    }]);

    return Group;
  }(FakeSVG);

  funcs.Group = function () {
    for (var _len24 = arguments.length, args = new Array(_len24), _key24 = 0; _key24 < _len24; _key24++) {
      args[_key24] = arguments[_key24];
    }

    return _construct(Group, args);
  };

  var Start = /*#__PURE__*/function (_FakeSVG8) {
    _inherits(Start, _FakeSVG8);

    var _super17 = _createSuper(Start);

    function Start() {
      var _this17;

      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$type = _ref.type,
          type = _ref$type === void 0 ? "simple" : _ref$type,
          label = _ref.label;

      _classCallCheck(this, Start);

      _this17 = _super17.call(this, 'g');
      _this17.width = 20;
      _this17.height = 0;
      _this17.up = 10;
      _this17.down = 10;
      _this17.type = type;

      if (label) {
        _this17.label = "" + label;
        _this17.width = Math.max(20, _this17.label.length * Options.CHAR_WIDTH + 10);
      }

      if (Options.DEBUG) {
        _this17.attrs['data-updown'] = _this17.up + " " + _this17.height + " " + _this17.down;
        _this17.attrs['data-type'] = "start";
      }

      return _this17;
    }

    _createClass(Start, [{
      key: "format",
      value: function format(x, y) {
        var path = new Path(x, y - 10);

        if (this.type === "complex") {
          path.down(20).m(0, -10).right(this.width).addTo(this);
        } else {
          path.down(20).m(10, -20).down(20).m(-10, -10).right(this.width).addTo(this);
        }

        if (this.label) {
          new FakeSVG('text', {
            x: x,
            y: y - 15,
            style: "text-anchor:start"
          }, this.label).addTo(this);
        }

        return this;
      }
    }]);

    return Start;
  }(FakeSVG);

  funcs.Start = function () {
    for (var _len25 = arguments.length, args = new Array(_len25), _key25 = 0; _key25 < _len25; _key25++) {
      args[_key25] = arguments[_key25];
    }

    return _construct(Start, args);
  };

  var End = /*#__PURE__*/function (_FakeSVG9) {
    _inherits(End, _FakeSVG9);

    var _super18 = _createSuper(End);

    function End() {
      var _this18;

      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$type = _ref2.type,
          type = _ref2$type === void 0 ? "simple" : _ref2$type;

      _classCallCheck(this, End);

      _this18 = _super18.call(this, 'path');
      _this18.width = 20;
      _this18.height = 0;
      _this18.up = 10;
      _this18.down = 10;
      _this18.type = type;

      if (Options.DEBUG) {
        _this18.attrs['data-updown'] = _this18.up + " " + _this18.height + " " + _this18.down;
        _this18.attrs['data-type'] = "end";
      }

      return _this18;
    }

    _createClass(End, [{
      key: "format",
      value: function format(x, y) {
        if (this.type === "complex") {
          this.attrs.d = 'M ' + x + ' ' + y + ' h 20 m 0 -10 v 20';
        } else {
          this.attrs.d = 'M ' + x + ' ' + y + ' h 20 m -10 -10 v 20 m 10 -20 v 20';
        }

        return this;
      }
    }]);

    return End;
  }(FakeSVG);

  funcs.End = function () {
    for (var _len26 = arguments.length, args = new Array(_len26), _key26 = 0; _key26 < _len26; _key26++) {
      args[_key26] = arguments[_key26];
    }

    return _construct(End, args);
  };

  var Terminal = /*#__PURE__*/function (_FakeSVG10) {
    _inherits(Terminal, _FakeSVG10);

    var _super19 = _createSuper(Terminal);

    function Terminal(text) {
      var _this19;

      var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          href = _ref3.href,
          title = _ref3.title;

      _classCallCheck(this, Terminal);

      _this19 = _super19.call(this, 'g', {
        'class': 'terminal'
      });
      _this19.text = "" + text;
      _this19.href = href;
      _this19.title = title;
      _this19.width = _this19.text.length * Options.CHAR_WIDTH + 20;
      _this19.height = 0;
      _this19.up = 11;
      _this19.down = 11;
      _this19.needsSpace = true;

      if (Options.DEBUG) {
        _this19.attrs['data-updown'] = _this19.up + " " + _this19.height + " " + _this19.down;
        _this19.attrs['data-type'] = "terminal";
      }

      return _this19;
    }

    _createClass(Terminal, [{
      key: "format",
      value: function format(x, y, width) {
        var gaps = determineGaps(width, this.width);
        new Path(x, y).h(gaps[0]).addTo(this);
        new Path(x + gaps[0] + this.width, y).h(gaps[1]).addTo(this);
        x += gaps[0];
        new FakeSVG('rect', {
          x: x,
          y: y - 11,
          width: this.width,
          height: this.up + this.down,
          rx: 10,
          ry: 10
        }).addTo(this);
        var text = new FakeSVG('text', {
          x: x + this.width / 2,
          y: y + 4
        }, this.text);
        if (this.href) new FakeSVG('a', {
          'xlink:href': this.href
        }, [text]).addTo(this);else text.addTo(this);
        if (this.title) new FakeSVG('title', {}, [this.title]).addTo(this);
        return this;
      }
    }]);

    return Terminal;
  }(FakeSVG);

  funcs.Terminal = function () {
    for (var _len27 = arguments.length, args = new Array(_len27), _key27 = 0; _key27 < _len27; _key27++) {
      args[_key27] = arguments[_key27];
    }

    return _construct(Terminal, args);
  };

  var NonTerminal = /*#__PURE__*/function (_FakeSVG11) {
    _inherits(NonTerminal, _FakeSVG11);

    var _super20 = _createSuper(NonTerminal);

    function NonTerminal(text) {
      var _this20;

      var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          href = _ref4.href,
          title = _ref4.title;

      _classCallCheck(this, NonTerminal);

      _this20 = _super20.call(this, 'g', {
        'class': 'non-terminal'
      });
      _this20.text = "" + text;
      _this20.href = href;
      _this20.title = title;
      _this20.width = _this20.text.length * Options.CHAR_WIDTH + 20;
      _this20.height = 0;
      _this20.up = 11;
      _this20.down = 11;
      _this20.needsSpace = true;

      if (Options.DEBUG) {
        _this20.attrs['data-updown'] = _this20.up + " " + _this20.height + " " + _this20.down;
        _this20.attrs['data-type'] = "nonterminal";
      }

      return _this20;
    }

    _createClass(NonTerminal, [{
      key: "format",
      value: function format(x, y, width) {
        var gaps = determineGaps(width, this.width);
        new Path(x, y).h(gaps[0]).addTo(this);
        new Path(x + gaps[0] + this.width, y).h(gaps[1]).addTo(this);
        x += gaps[0];
        new FakeSVG('rect', {
          x: x,
          y: y - 11,
          width: this.width,
          height: this.up + this.down
        }).addTo(this);
        var text = new FakeSVG('text', {
          x: x + this.width / 2,
          y: y + 4
        }, this.text);
        if (this.href) new FakeSVG('a', {
          'xlink:href': this.href
        }, [text]).addTo(this);else text.addTo(this);
        if (this.title) new FakeSVG('title', {}, [this.title]).addTo(this);
        return this;
      }
    }]);

    return NonTerminal;
  }(FakeSVG);

  funcs.NonTerminal = function () {
    for (var _len28 = arguments.length, args = new Array(_len28), _key28 = 0; _key28 < _len28; _key28++) {
      args[_key28] = arguments[_key28];
    }

    return _construct(NonTerminal, args);
  };

  var Comment = /*#__PURE__*/function (_FakeSVG12) {
    _inherits(Comment, _FakeSVG12);

    var _super21 = _createSuper(Comment);

    function Comment(text) {
      var _this21;

      var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          href = _ref5.href,
          title = _ref5.title;

      _classCallCheck(this, Comment);

      _this21 = _super21.call(this, 'g');
      _this21.text = "" + text;
      _this21.href = href;
      _this21.title = title;
      _this21.width = _this21.text.length * Options.COMMENT_CHAR_WIDTH + 10;
      _this21.height = 0;
      _this21.up = 8;
      _this21.down = 8;
      _this21.needsSpace = true;

      if (Options.DEBUG) {
        _this21.attrs['data-updown'] = _this21.up + " " + _this21.height + " " + _this21.down;
        _this21.attrs['data-type'] = "comment";
      }

      return _this21;
    }

    _createClass(Comment, [{
      key: "format",
      value: function format(x, y, width) {
        var gaps = determineGaps(width, this.width);
        new Path(x, y).h(gaps[0]).addTo(this);
        new Path(x + gaps[0] + this.width, y + this.height).h(gaps[1]).addTo(this);
        x += gaps[0];
        var text = new FakeSVG('text', {
          x: x + this.width / 2,
          y: y + 5,
          "class": 'comment'
        }, this.text);
        if (this.href) new FakeSVG('a', {
          'xlink:href': this.href
        }, [text]).addTo(this);else text.addTo(this);
        if (this.title) new FakeSVG('title', {}, this.title).addTo(this);
        return this;
      }
    }]);

    return Comment;
  }(FakeSVG);

  funcs.Comment = function () {
    for (var _len29 = arguments.length, args = new Array(_len29), _key29 = 0; _key29 < _len29; _key29++) {
      args[_key29] = arguments[_key29];
    }

    return _construct(Comment, args);
  };

  var Skip = /*#__PURE__*/function (_FakeSVG13) {
    _inherits(Skip, _FakeSVG13);

    var _super22 = _createSuper(Skip);

    function Skip() {
      var _this22;

      _classCallCheck(this, Skip);

      _this22 = _super22.call(this, 'g');
      _this22.width = 0;
      _this22.height = 0;
      _this22.up = 0;
      _this22.down = 0;
      _this22.needsSpace = false;

      if (Options.DEBUG) {
        _this22.attrs['data-updown'] = _this22.up + " " + _this22.height + " " + _this22.down;
        _this22.attrs['data-type'] = "skip";
      }

      return _this22;
    }

    _createClass(Skip, [{
      key: "format",
      value: function format(x, y, width) {
        new Path(x, y).right(width).addTo(this);
        return this;
      }
    }]);

    return Skip;
  }(FakeSVG);

  funcs.Skip = function () {
    for (var _len30 = arguments.length, args = new Array(_len30), _key30 = 0; _key30 < _len30; _key30++) {
      args[_key30] = arguments[_key30];
    }

    return _construct(Skip, args);
  };

  var Block = /*#__PURE__*/function (_FakeSVG14) {
    _inherits(Block, _FakeSVG14);

    var _super23 = _createSuper(Block);

    function Block() {
      var _this23;

      var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref6$width = _ref6.width,
          width = _ref6$width === void 0 ? 50 : _ref6$width,
          _ref6$up = _ref6.up,
          up = _ref6$up === void 0 ? 15 : _ref6$up,
          _ref6$height = _ref6.height,
          height = _ref6$height === void 0 ? 25 : _ref6$height,
          _ref6$down = _ref6.down,
          down = _ref6$down === void 0 ? 15 : _ref6$down,
          _ref6$needsSpace = _ref6.needsSpace,
          needsSpace = _ref6$needsSpace === void 0 ? true : _ref6$needsSpace;

      _classCallCheck(this, Block);

      _this23 = _super23.call(this, 'g');
      _this23.width = width;
      _this23.height = height;
      _this23.up = up;
      _this23.down = down;
      _this23.needsSpace = needsSpace;

      if (Options.DEBUG) {
        _this23.attrs['data-updown'] = _this23.up + " " + _this23.height + " " + _this23.down;
        _this23.attrs['data-type'] = "block";
      }

      return _this23;
    }

    _createClass(Block, [{
      key: "format",
      value: function format(x, y, width) {
        var gaps = determineGaps(width, this.width);
        new Path(x, y).h(gaps[0]).addTo(this);
        new Path(x + gaps[0] + this.width, y).h(gaps[1]).addTo(this);
        x += gaps[0];
        new FakeSVG('rect', {
          x: x,
          y: y - this.up,
          width: this.width,
          height: this.up + this.height + this.down
        }).addTo(this);
        return this;
      }
    }]);

    return Block;
  }(FakeSVG);

  funcs.Block = function () {
    for (var _len31 = arguments.length, args = new Array(_len31), _key31 = 0; _key31 < _len31; _key31++) {
      args[_key31] = arguments[_key31];
    }

    return _construct(Block, args);
  };

  function unnull() {
    for (var _len32 = arguments.length, args = new Array(_len32), _key32 = 0; _key32 < _len32; _key32++) {
      args[_key32] = arguments[_key32];
    }

    return args.reduce(function (sofar, x) {
      return sofar !== undefined ? sofar : x;
    });
  }

  function determineGaps(outer, inner) {
    var diff = outer - inner;

    switch (Options.INTERNAL_ALIGNMENT) {
      case 'left':
        return [0, diff];

      case 'right':
        return [diff, 0];

      default:
        return [diff / 2, diff / 2];
    }
  }

  function wrapString(value) {
    return value instanceof FakeSVG ? value : new Terminal("" + value);
  }

  function sum(iter, func) {
    if (!func) func = function func(x) {
      return x;
    };
    return iter.map(func).reduce(function (a, b) {
      return a + b;
    }, 0);
  }

  function max(iter, func) {
    if (!func) func = function func(x) {
      return x;
    };
    return Math.max.apply(null, iter.map(func));
  }

  function SVG(name, attrs, text) {
    attrs = attrs || {};
    text = text || '';
    var el = document.createElementNS("http://www.w3.org/2000/svg", name);

    for (var attr in attrs) {
      if (attr === 'xlink:href') el.setAttributeNS("http://www.w3.org/1999/xlink", 'href', attrs[attr]);else el.setAttribute(attr, attrs[attr]);
    }

    el.textContent = text;
    return el;
  }

  function escapeString(string) {
    return string.replace(/[*_`[\]<&]/g, function (charString) {
      return '&#' + charString.charCodeAt(0) + ';';
    });
  }

  function enumerate(iter) {
    var count, _iterator3, _step3, x;

    return _regeneratorRuntime.wrap(function enumerate$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            count = 0;
            _iterator3 = _createForOfIteratorHelper(iter);
            _context.prev = 2;

            _iterator3.s();

          case 4:
            if ((_step3 = _iterator3.n()).done) {
              _context.next = 11;
              break;
            }

            x = _step3.value;
            _context.next = 8;
            return [count, x];

          case 8:
            count++;

          case 9:
            _context.next = 4;
            break;

          case 11:
            _context.next = 16;
            break;

          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](2);

            _iterator3.e(_context.t0);

          case 16:
            _context.prev = 16;

            _iterator3.f();

            return _context.finish(16);

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _marked, null, [[2, 13, 16, 19]]);
  }

  function diagramFromJSON(Diagram, input) {
    if (!input) return new Diagram();

    if (Array.isArray(input)) {
      return _construct(Diagram, _toConsumableArray(input.map(nodeFromJSON)));
    }

    switch (input.type) {
      case 'Diagram':
      case 'ComplexDiagram':
        return nodeFromJSON(input);
    }

    return new Diagram(nodeFromJSON(input));
  }

  var classes = {
    Diagram: Diagram,
    ComplexDiagram: ComplexDiagram,
    Sequence: Sequence,
    Stack: Stack,
    VerticalSequence: VerticalSequence,
    OptionalSequence: OptionalSequence,
    HorizontalChoice: HorizontalChoice,
    AlternatingSequence: AlternatingSequence,
    Choice: Choice,
    MultipleChoice: MultipleChoice,
    Optional: Optional,
    OneOrMore: OneOrMore,
    ZeroOrMore: ZeroOrMore,
    Group: Group,
    Start: Start,
    End: End,
    Terminal: Terminal,
    NonTerminal: NonTerminal,
    Comment: Comment,
    Skip: Skip
  };

  function nodeFromJSON(node) {
    if (!node) return;
    var Node = classes[node.type];

    switch (Node) {
      case Diagram:
      case ComplexDiagram:
      case Sequence:
      case Stack:
      case VerticalSequence:
      case OptionalSequence:
      case HorizontalChoice:
        return _construct(Node, _toConsumableArray(itemsFromJSON(node.items)));

      case AlternatingSequence:
        return new Node(nodeFromJSON(node.option1), nodeFromJSON(node.option2));

      case Choice:
        return _construct(Node, [node.normalIndex || 0].concat(_toConsumableArray(itemsFromJSON(node.options))));

      case MultipleChoice:
        return _construct(Node, [node.normalIndex || 0, node.choiceType].concat(_toConsumableArray(itemsFromJSON(node.options))));

      case Optional:
        return new Node(nodeFromJSON(node.item), node.skip && 'skip');

      case OneOrMore:
        return new Node(nodeFromJSON(node.item), nodeFromJSON(node.repeat));

      case ZeroOrMore:
        return new Node(nodeFromJSON(node.item), nodeFromJSON(node.repeat), node.skip && 'skip');

      case Group:
        return new Node(nodeFromJSON(node.item), node.label);

      case Start:
        return new Node(node.startType, node.label);

      case End:
        return new Node(node.endType);

      case Terminal:
      case NonTerminal:
      case Comment:
        return new Node(node.text, {
          href: node.href,
          title: node.title
        });

      case Skip:
        return new Node();
    }

    throw new Error("Unknown node type: \"".concat(node.type, "\"."));
  }

  function itemsFromJSON(items) {
    return items ? items.map(nodeFromJSON) : [];
  }

  exports.AlternatingSequence = AlternatingSequence;
  exports.Block = Block;
  exports.Choice = Choice;
  exports.Comment = Comment;
  exports.ComplexDiagram = ComplexDiagram;
  exports.Diagram = Diagram;
  exports.DiagramMultiContainer = DiagramMultiContainer;
  exports.End = End;
  exports.FakeSVG = FakeSVG;
  exports.Group = Group;
  exports.HorizontalChoice = HorizontalChoice;
  exports.MultipleChoice = MultipleChoice;
  exports.NonTerminal = NonTerminal;
  exports.OneOrMore = OneOrMore;
  exports.Optional = Optional;
  exports.OptionalSequence = OptionalSequence;
  exports.Options = Options;
  exports.Path = Path;
  exports.Sequence = Sequence;
  exports.Skip = Skip;
  exports.Stack = Stack;
  exports.Start = Start;
  exports.Terminal = Terminal;
  exports.VerticalSequence = VerticalSequence;
  exports.ZeroOrMore = ZeroOrMore;
  exports["default"] = funcs;
  exports.defaultCSS = defaultCSS;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});